import { css } from 'styled-components';
import { VariantOfType } from '../../variants';

export const CssRadioCardDefault = css`
`;

export const radioCardVariants = {
  default: CssRadioCardDefault,
};

export type IRadioCardVariants = VariantOfType<typeof radioCardVariants>;
